export default __webpack_public_path__ + "static/media/faq.f1c2dbd3.svg";